import styled from "styled-components";
import { Button } from "reactstrap";

export const Label = styled.label`
    font-size: 1rem;
    font-weight: 500;
`;

export const SpanRequired = styled.span`
   color: red;
`;

export const ButtonAdd = styled(Button)`
    border: 0px solid transparent !important;
    padding: 0.275rem 0.75rem !important;
`;

export const CardItem = styled.div`
    border: 1px solid #D2D2D2;
    padding: 5px;
    box-shadow: 3px 3px 4px #D2D2D2;
`;

export const CardContainer = styled.div`
    display: inline-flex;
    width: 100%;
`;

export const CardDivButtons = styled.div`
    width: 45%; 
    text-align: right !important; 
    font-weight: 500; 
    padding-right: 10px;

    img {
        width: 25px !important; 
        margin-left: 10px; 
        cursor: pointer;
    }
`;

export const CardDivStatus = styled.div`
    width: 60%;
    font-size: 1.2rem;
    font-weight: 500;
`;

export const CardLabelStatus = styled.label`
    font-size: 10px;
    color: #B5B5B5;
    margin-left: 3px;
`;